<template>
  <div class="v2-brand-collections">
    <div
      v-if="!collectionsLoaded"
      class="v2-page-loading"
    >
      <v2-spinner
        size="lg"
        label="Loading..."
      />
    </div>
    <template v-else>
      <!-- Tabs -->
      <div class="v2-brand-collections__tabs">
        <button
          class="v2-brand-collections__tab"
          :class="{ 'v2-brand-collections__tab--active': activeTab === 'active' }"
          @click="activeTab = 'active'"
        >
          ACTIVE COLLECTIONS
        </button>
        <button
          class="v2-brand-collections__tab"
          :class="{ 'v2-brand-collections__tab--active': activeTab === 'previous' }"
          @click="activeTab = 'previous'"
        >
          PREVIOUS COLLECTIONS
        </button>
      </div>

      <!-- Active Collections -->
      <template v-if="activeTab === 'active'">
        <div
          v-if="liveCollections.length"
          class="v2-brand-collections__grid"
        >
          <v2-collection-card
            v-for="collection in liveCollections"
            :key="collection._id"
            :collection="collection"
            :fetch-collections="onFetchCollections"
            @show-download-modal="openDownloadModal"
          />
        </div>
        <div
          v-else
          class="v2-brand-collections__empty"
        >
          <p class="v2-brand-collections__empty-text">
            The brand doesn't have any active collections. You'll get
            notification, when the brand uploaded the new one.
          </p>
        </div>
      </template>

      <!-- Previous Collections -->
      <template v-if="activeTab === 'previous'">
        <div
          v-if="previousCollections.length"
          class="v2-brand-collections__grid"
        >
          <v2-collection-card
            v-for="collection in previousCollections"
            :key="collection._id"
            :collection="collection"
            is-previous-collection
            :fetch-collections="onFetchCollections"
            @show-download-modal="openDownloadModal"
          />
        </div>
        <div
          v-else
          class="v2-brand-collections__empty"
        >
          <p class="v2-brand-collections__empty-text">
            This brand doesn't have any previous collections.
          </p>
        </div>
      </template>

      <!-- Download Modal -->
      <v2-download-catalog-modal
        :show="showDownloadModal"
        :collection="selectedCollection"
        :retailer-id="downloadRetailerId"
        @close="showDownloadModal = false"
      />
    </template>
  </div>
</template>

<script>
import V2Spinner from '@/components/v2/V2Spinner.vue'
import V2CollectionCard from '@/views/v2/collection/V2CollectionCard.vue'
import V2DownloadCatalogModal from '@/views/v2/collection/V2DownloadCatalogModal.vue'

export default {
  name: 'V2BrandCollections',
  components: {
    V2Spinner,
    V2CollectionCard,
    V2DownloadCatalogModal,
  },
  props: {
    liveCollections: { type: Array, default: () => [] },
    previousCollections: { type: Array, default: () => [] },
    collectionsLoaded: { type: Boolean, default: false },
    fetchCollections: { type: Function, default: () => {} },
  },
  data() {
    return {
      activeTab: 'active',
      selectedCollection: {},
      showDownloadModal: false,
    }
  },
  computed: {
    downloadRetailerId() {
      return this.$store.getters.selectedDirectRetailer?.retailerId
        || this.$route.query.retailerId
        || null
    },
  },
  methods: {
    onFetchCollections() {
      this.fetchCollections()
    },
    openDownloadModal(collectionId) {
      const collection = [...this.liveCollections, ...this.previousCollections]
        .find(c => c._id === collectionId)
      if (collection) {
        this.selectedCollection = collection
        this.showDownloadModal = true
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-brand-collections {
  flex: 1;
  margin-top: var(--v2-space-4);

  &__tabs {
    display: flex;
    border-bottom: 1px solid var(--v2-border);
    margin-bottom: var(--v2-space-6);
  }

  &__tab {
    padding: var(--v2-space-3) var(--v2-space-4);
    font-family: var(--v2-font-sans);
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--v2-muted-foreground);
    background: none;
    border: none;
    border-bottom: 2px solid transparent;
    cursor: pointer;
    text-transform: uppercase;
    transition: all 0.15s ease;

    &--active {
      color: var(--v2-foreground);
      border-bottom-color: var(--v2-foreground);
    }

    &:hover:not(&--active) {
      color: var(--v2-foreground);
    }
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, 290px);
    gap: var(--v2-space-6);
  }

  &__empty {
    padding: var(--v2-space-12) 0;
    text-align: center;
  }

  &__empty-text {
    font-family: var(--v2-font-sans);
    font-size: 0.875rem;
    color: var(--v2-muted-foreground);
  }
}
</style>
